/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import { createContext } from 'react';

export const BrandContext = createContext();
